import axios from "axios";
import moment from "moment";
import { authService } from "../services/auth.service";
import api from "../services/api.service";
import useFetch from "../hooks/useFetch";
import useApi from "../hooks/useApi";
import { API_BASE_URL } from "../services/api.config";
import { 
  transformDate, 
  transformHistoryDate, 
  transformRawDate, 
  transformOxygenData 
} from "../services/transformers/api.transformer";

axios.defaults.baseURL = API_BASE_URL;
// axios.defaults.baseURL = `https://uubpfx3gbf.us-east-1.awsapprunner.com/api`;
// axios.defaults.baseURL = "http://localhost:3000/api";
// axios.defaults.baseURL = "https://apitest.ibicare.mx/api";
axios.defaults.headers.common["sessiontoken"] =
  sessionStorage.getItem("satiAuth");

// For backward compatibility within this file if needed, 
// though we're replacing their usage.
const formatDate = transformDate;
const formatDateHR = transformHistoryDate;
const formatDateRawHR = transformRawDate;
const formatDateOxygen = transformOxygenData;

const satiLogin = (user_name, password) => {
  return new Promise((res, rej) =>
    authService
      .login(user_name, password)
      .then((resp) => {
        const {
          data: { sessiontoken },
        } = resp;

        // Keep legacy axios sync
        axios.defaults.headers.common["sessiontoken"] = sessiontoken;
        return res(resp);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 400) {
          return rej("Credenciales inválidos");
        }
        return rej(err.message);
      }),
  );
};

const satiLogout = () => {
  return new Promise((res) => {
    authService.logout();
    // Keep legacy axios sync
    delete axios.defaults.headers.common["sessiontoken"];
    return res({});
  });
};

const myUser = () => {
  return api.get("/users/myUser").then((resp) => resp.data);
};

const getUserById = (idUser) => {
  return api.get("/users/getUserId/" + idUser).then((resp) => resp.data);
};

const patchUser = (data) => api.patch("/users/myUser", data);

const getUserData = (start, end) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/clockData/myData", { params })
    .then(({ data }) => formatDate(data))
    .catch((err) => err);
};

const getUserWeekData = () => {
  const today = moment();

  const params = {
    day: today.date(),
    month: today.month() + 1,
    year: today.year(),
  };

  return axios
    .get("/clockData/myData/week", { params })
    .then(({ data }) => formatDate(data))
    .catch((err) => err);
};

const getUserWeekTemperature = () => {
  const startOfWeek = moment().startOf("isoWeek");
  const endOfWeek = moment().endOf("isoWeek");

  const params = {
    yearI: startOfWeek.format("Y"),
    monthI: startOfWeek.format("M"),
    dayI: startOfWeek.format("D"),
    yearF: endOfWeek.format("Y"),
    monthF: endOfWeek.format("M"),
    dayF: endOfWeek.format("D"),
  };

  return axios
    .get("/temperature/myData", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserWeekOxygen = () => {
  const startOfWeek = moment().startOf("isoWeek");
  const endOfWeek = moment().endOf("isoWeek");

  const params = {
    yearI: startOfWeek.format("Y"),
    monthI: startOfWeek.format("M"),
    dayI: startOfWeek.format("D"),
    yearF: endOfWeek.format("Y"),
    monthF: endOfWeek.format("M"),
    dayF: endOfWeek.format("D"),
  };

  return axios
    .get("/oxygen/myData", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserHeartRate = (start, end, userId) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/heartRate/user/" + userId, { params })
    .then(({ data }) => formatDateHR(data))
    .catch((err) => err);
};

const getUserOxygenByCompany = (start, end, userId) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/oxygen/user/" + userId, { params })
    .then(({ data }) => formatDateOxygen(data))
    .catch((err) => err);
};

const getUserSummaryRange = (start, end) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/summary/mySummary/range", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserSummayMonth = () => {
  return axios
    .get("/summary/mySummary/month")
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserTemperature = (start, end) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/temperature/myData", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserOxygen = (start, end) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/oxygen/myData", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getUserWeekSummary = () => {
  const today = moment();

  const params = {
    day: today.date(),
    month: today.month() + 1,
    year: today.year(),
  };

  return axios
    .get("/summary/mySummary/week", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getChallenges = () => {
  return axios
    .get("/retos/today")
    .then(({ data }) => data)
    .catch((err) => err);
};

const getMonthlyChallenges = () => {
  return axios
    .get("/retos/monthly")
    .then(({ data }) => data)
    .catch((err) => err);
};

const appendDiseaseFilter = (params, diseaseName) =>
  diseaseName ? { ...params, enfermedad: diseaseName } : params;

const getDiseases = () => {
  return axios
    .get("/summary/diseases")
    .then(({ data }) => data && data.data ? data.data : data)
    .catch((err) => err);
};

const getCompanyUsers = (start, end, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/summary/companyUsers", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const postManualHealthData = (payload) =>
  api.post("/clockData/manual", payload).then(({ data }) => data);

const getAllCompanyUsers = (start, end) => {
  const params = {};

  return axios
    .get("/users/myCompanyUsers", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getCompanyData = (start, end, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/clockData/companyData", { params })
    .then(({ data }) => formatDate(data))
    .catch((err) => err);
};

const getPoblationalData = (start, end, diseaseName) => {
  const params = appendDiseaseFilter({
    dateI: start.format("YYYY-MM-DD"),
    dateF: end.format("YYYY-MM-DD"),
  }, diseaseName);

  return axios
    .get("/poblational/poblational", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};


const getAreas = (start, end, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/summary/companyAreas", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getAreaUsers = (start, end, areaId, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    areaId,
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/summary/areaUsers", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const getAreaData = (start, end, areaId, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    areaId,
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/clockData/areaData", { params })
    .then(({ data }) => formatDate(data))
    .catch((err) => err);
};

const getUserIndividualData = (start, end, userId, diseaseName) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = appendDiseaseFilter({
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  }, diseaseName);

  return axios
    .get("/clockData/user/" + userId, { params })
    .then(({ data }) => formatDate(data))
    .catch((err) => err);
};

const getUserIndividualSleep = (start, end, userId) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };
  return axios
    .get("/sleep/" + userId, { params })
    .then(({ data }) => formatDateHR(data))
    .catch((err) => err);
};

const getUserIndividualSleepWeek = (userId) => {
  const startOfWeek = moment().startOf("isoWeek");
  const endOfWeek = moment().endOf("isoWeek");

  const params = {
    yearI: startOfWeek.format("Y"),
    monthI: startOfWeek.format("M"),
    dayI: startOfWeek.format("D"),
    yearF: endOfWeek.format("Y"),
    monthF: endOfWeek.format("M"),
    dayF: endOfWeek.format("D"),
  };

  return axios
    .get("/sleep/" + userId, { params })
    .then(({ data }) => formatDateHR(data))
    .catch((err) => err);
};

const getUserIndividualHeartRate = (start, end, userId) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/heartrate/raw/user/" + userId, { params })
    .then(({ data }) => formatDateRawHR(data))
    .catch((err) => err);
};

const getAdminData = (start, end) => {
  const startDay = start.date();
  const startMon = start.month() + 1;
  const startYear = start.year();
  const endDay = end.date();
  const endMon = end.month() + 1;
  const endYear = end.year();

  const params = {
    dayI: startDay,
    monthI: startMon,
    yearI: startYear,
    dayF: endDay,
    monthF: endMon,
    yearF: endYear,
  };

  return axios
    .get("/summary/adminSummary", { params })
    .then(({ data }) => data)
    .catch((err) => err);
};

const useSections = () => {
  return useFetch(() =>
    api.get("/contents", {
      data: {
        type: "HealthWeek",
      },
    }),
  );
};

const useCreateTrackingData = () => {
  const { execute, ...state } = useApi((payload) =>
    api.post("/tracking", payload),
  );
  return { ...state, mutateAsync: execute };
};

const useUser = () => {
  return useFetch(() => api.get("/users/myUser"));
};

const useResources = ({ subsectionId }) => {
  return useFetch(() => api.get(`/contents/resources/${subsectionId}`), [
    subsectionId,
  ]);
};

const useRanking = (filter, date) => {
  const formattedDate = moment(date).format('YYYY-MM-DD');
  
  return useFetch(
    () => api.get(`/summary/company-ranking/${filter}/?date=${formattedDate}`),
    [filter, date],
  );
};

const createMonthlyChallenge = (challengeData) => {
  return new Promise((res, rej) => {
    axios
      .post(
        "/retos/monthly",
        challengeData,
        challengeData instanceof FormData
          ? { headers: { "Content-Type": "multipart/form-data" } }
          : undefined,
      )
      .then((resp) => res(resp.data))
      .catch((err) => rej(err));
  });
};

const addChallengeStop = (monthlyChallengeId, stopData) => {
  return new Promise((res, rej) => {
    axios
      .post(`/retos/monthly/${monthlyChallengeId}/stops`, stopData)
      .then((resp) => res(resp.data))
      .catch((err) => rej(err));
  });
};

const updateMonthlyChallenge = (monthlyChallengeId, challengeData) => {
  return new Promise((res, rej) => {
    console.log("updateMonthlyChallenge called with:", {
      monthlyChallengeId,
      isFormData: challengeData instanceof FormData,
    });

    // Try PATCH first, but fallback to POST if it fails (some browsers have issues with PATCH + FormData)
    const tryPatch = () => {
      const config = {
        method: "PATCH",
        url: `/retos/monthly/${monthlyChallengeId}`,
        data: challengeData,
      };

      if (!(challengeData instanceof FormData)) {
        config.headers = { "Content-Type": "application/json" };
      }

      return axios(config);
    };

    const tryPost = () => {
      const config = {
        method: "POST",
        url: `/retos/monthly/${monthlyChallengeId}/update`,
        data: challengeData,
      };

      if (!(challengeData instanceof FormData)) {
        config.headers = { "Content-Type": "application/json" };
      }

      return axios(config);
    };

    // Try PATCH first
    tryPatch()
      .then((resp) => {
        console.log("PATCH request successful:", resp.status);
        res(resp.data);
      })
      .catch((err) => {
        console.warn("PATCH failed, trying POST fallback:", err.message);
        // Fallback to POST if PATCH fails
        tryPost()
          .then((resp) => {
            console.log("POST request successful:", resp.status);
            res(resp.data);
          })
          .catch((postErr) => {
            console.error("Both PATCH and POST failed:", postErr);
            if (postErr.response) {
              console.error(
                "Response error:",
                postErr.response.status,
                postErr.response.data,
              );
            } else if (postErr.request) {
              console.error("Request error:", postErr.request);
            } else {
              console.error("Error:", postErr.message);
            }
            rej(postErr);
          });
      });
  });
};

const deleteMonthlyChallenge = (monthlyChallengeId) => {
  return new Promise((res, rej) => {
    axios
      .delete(`/retos/monthly/${monthlyChallengeId}`)
      .then((resp) => res(resp.data))
      .catch((err) => rej(err));
  });
};

export {
  satiLogin,
  satiLogout,
  myUser,
  getUserById,
  patchUser,
  getUserData,
  getUserWeekData,
  getUserWeekTemperature,
  getUserWeekOxygen,
  getUserSummayMonth,
  getUserSummaryRange,
  getUserTemperature,
  getUserOxygen,
  getUserWeekSummary,
  getChallenges,
  getMonthlyChallenges,
  getCompanyUsers,
  getDiseases,
  postManualHealthData,
  getAllCompanyUsers,
  getCompanyData,
  getPoblationalData,
  getAreas,
  getAreaUsers,
  getAreaData,
  getAdminData,
  getUserHeartRate,
  getUserIndividualData,
  getUserIndividualSleep,
  getUserIndividualSleepWeek,
  getUserIndividualHeartRate,
  getUserOxygenByCompany,
  useSections,
  useCreateTrackingData,
  useUser,
  useResources,
  useRanking,
  createMonthlyChallenge,
  addChallengeStop,
  updateMonthlyChallenge,
  deleteMonthlyChallenge,
};
